export const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
    marginRight: 40,
  },
  title: {
    fontSize: 36,
    color: 'var(--color-text-primary)',
    fontWeight: 700,
    margin: '64px 0px 8px',
  },
  subtitle: {
    fontSize: 18,
    color: 'var(--color-oxford-blue)',
    fontWeight: 400,
    margin: '0px 0px 16px',
  },
  text: {
    color: 'rgb(53,64,82,0.7)',
    fontSize: 14,
    margin: '0px 0px 24px',
  },
  button: {
    padding: '13px 28px',
    border: 0,
    background: 'var(--color-general-ui)',
    boxShadow: '0px 3px 9px rgba(19, 69, 186, 0.206267)',
    borderRadius: 10,
    cursor: 'pointer',
    color: 'var(--color-text-on-primary)',
    margin: '30px auto 0',
    display: 'block',
  },
})
